export enum SettingsStoreActions {
    LoadSettingsFromBackend = 'LOAD_SETTINGS_FROM_BACKEND',
    UpdateSettings = 'UPDATE_SETTINGS',
    InitializeSettings = 'INITIALIZE_SETTINGS'
}
